export const AGREEMENT_PREFIX = 'AGR';
export const ALLIANCE_PREFIX = 'ALL';
export const AMENDMENT_PREFIX = 'AMD';
export const LEAD_PREFIX = 'OPP';
export const OBLIGATION_PREFIX = 'OBL';
export const TASK_PREFIX = 'TSK';
